(function () {
  /** @param {Element | null} activeTile */
  function setActiveTile(activeTile) {
    document.querySelectorAll('.atomberg-cf__tile').forEach(function (tile) {
      var isActive = tile === activeTile;
      tile.classList.toggle('atomberg-cf__tile--active', isActive);
      if (isActive) {
        tile.setAttribute('aria-current', 'page');
      } else {
        tile.removeAttribute('aria-current');
      }
    });
  }

  /**
   * Find the Collection Products section anywhere on the page.
   * @returns {HTMLElement | null}
   */
  function findProductsSection() {
    var el = document.querySelector('[data-atomberg-cp]');
    return el instanceof HTMLElement ? el : null;
  }

  /**
   * Replace the live `#shopify-section-{id}` wrapper with the freshly-fetched
   * version. Uses Shopify's Section Rendering API so native filters/sort and
   * our card layout both update together — no URL change, no page reload.
   * @param {string} handle
   * @param {HTMLElement} cp
   * @param {Element} tile
   */
  async function loadCollection(handle, cp, tile) {
    setActiveTile(tile);

    var sectionId = cp.dataset.sectionId;
    if (!sectionId) return;

    var wrapperId = 'shopify-section-' + sectionId;
    var wrapper = document.getElementById(wrapperId);
    if (!wrapper) return;

    cp.classList.add('atomberg-cp--loading');

    try {
      var res = await fetch(
        '/collections/' + handle + '?section_id=' + encodeURIComponent(sectionId)
      );
      if (!res.ok) throw new Error(String(res.status));

      var html = await res.text();
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      var nextWrapper = doc.getElementById(wrapperId);
      var nextInner = nextWrapper ? nextWrapper : doc.querySelector('[data-atomberg-cp]');
      if (!nextInner) return;

      if (nextWrapper) {
        wrapper.replaceWith(nextWrapper);
      } else {
        wrapper.innerHTML = nextInner.outerHTML;
      }
    } catch {
      cp.classList.remove('atomberg-cp--loading');
    }
  }

  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var tile = e.target.closest('.atomberg-cf__tile');
    if (!tile) return;

    var handle = tile instanceof HTMLElement ? tile.dataset.collectionHandle : null;
    if (!handle) {
      // URL-only tile — let the browser navigate normally.
      return;
    }

    if (tile.classList.contains('atomberg-cf__tile--active')) {
      e.preventDefault();
      return;
    }

    var cp = findProductsSection();
    if (!cp) {
      // No Collection Products section on this page — let the link navigate.
      return;
    }

    e.preventDefault();
    loadCollection(handle, cp, tile);
  });
})();
